import { isWxWork } from '@/api/utils/thousands.js';
export default {
  created() {
    if (!isWxWork()) {
      let split = window.location.href.split('/');
      let pageType = split[split.length - 1];
      if (pageType !== 'cvaSign' && pageType !== 'cva' && pageType !== 'error') {
        this.$router.replace('/error');
        return;
      }
    }
    window.onload = function () {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault();
      });
    };
  }
};